import { IRoutine } from '../Const/Delsystem';
import { rutiner } from '../Const/Rutiner';
import { styrvarden } from '../Const/Styrvarden';

export const findRutin = (rutinKey: string): IRoutine | undefined =>
  rutiner[rutinKey];
export const findStyrvärde = (rutinKey: string): IRoutine | undefined =>
  styrvarden()[rutinKey];
export const findRutinOrStyrvärde = (rutinKey: string): IRoutine | undefined =>
  rutiner[rutinKey] ?? styrvarden()[rutinKey];
